import { ShoppingCart } from "@vivagym-joining/shopping-cart";

class VgRenderBasket {
	constructor() {
		this.shoppingCart = new ShoppingCart();
	}

	renderBasketPreview(progress) {
		if (!progress.getBasketResume()) {
			return;
		}
		this.emptyBasketPreview();
		this.renderBasketPreviewPrice(progress, 'monthly');
		this.renderBasketPreviewPrice(progress, 'paynow');

		this.removeBasketLoading();
	}

	emptyBasketPreview() {
		const basketElementMonthly = document.getElementById("vg-select-quote__cart-basket--monthly");
		const basketElementPayNow = document.getElementById("vg-select-quote__cart-basket--paynow");

		if (basketElementMonthly) {
			basketElementMonthly.innerHTML = '';
		}

		if (basketElementPayNow) {
			basketElementPayNow.innerHTML = '';
		}
	}

	renderBasketPreviewPrice(progress, type) {
		let dataResume;
		let dataBasket = progress.getBasket();

		let elementId = '';
		let headingLiteral = '';

		switch (type) {
			case 'monthly':
				dataResume = progress.getBasketResume().monthlyPrice;
				elementId = "vg-select-quote__cart-basket--monthly";
				if (typeof JoiningVars !== 'undefined') {
					headingLiteral = JoiningVars.get_form_field("pago-mensual");
				}
				break;
			case 'paynow':
				dataResume = progress.getBasketResume().payNowPrice;
				elementId = "vg-select-quote__cart-basket--paynow";
				if (typeof JoiningVars !== 'undefined') {
					headingLiteral = JoiningVars.get_form_field("pago-unico");
				}
				break;
			default:
				return null;
		}

		if (dataResume === 0) {
			this.renderBasketPreviewMobile(type, '', '');
			return;
		}

		const basketElement = document.getElementById(elementId);

		if (basketElement) {

			const subtitleElement = document.createElement('div');
			subtitleElement.classList.add('vg-select-quote__cart-summary-subtitle', 'has-subtitle-s-font-size');
			subtitleElement.innerHTML = headingLiteral;

			basketElement.appendChild(subtitleElement);

			const tableBasketElement = document.createElement('table');
			tableBasketElement.classList.add('vg-select-quote__cart-summary-detail');

			const tableBodyBasketElement = document.createElement('tbody');
			let htmlTBody = '';
			let totalPrice = 0;

			let tableData = this.shoppingCart.getBasketCuoteDataTable(dataResume.fee, dataBasket, type, 'fee');
			let [htmlTable, totalTable] = this.renderItemTable(tableData);
			htmlTBody += htmlTable;
			totalPrice += totalTable;

			tableData = this.shoppingCart.getBasketCuoteDataTable(dataResume.extras, dataBasket, type, 'extras');
			[htmlTable, totalTable] = this.renderItemTable(tableData);
			htmlTBody += htmlTable;
			totalPrice += totalTable;

			if (type === 'paynow') {
				tableData = this.shoppingCart.getBasketCuoteDataTable(dataResume.others, dataBasket, type, 'others');
				[htmlTable, totalTable] = this.renderItemTable(tableData);
				htmlTBody += htmlTable;
				totalPrice += totalTable;
			}
			tableBodyBasketElement.innerHTML = htmlTBody;
			tableBasketElement.appendChild(tableBodyBasketElement);
			tableBasketElement.appendChild(this.renderTotalPrice(totalPrice));

			this.renderBasketPreviewMobile(type, headingLiteral, totalPrice);

			basketElement.appendChild(tableBasketElement);
		}
	}

	renderBasketPreviewMobile(type, headingLiteral, totalPrice) {
		const mobileElement = document.getElementById('vg-select-quote__cart-basket--detail-mobile');
		if (!mobileElement) {
			return;
		}

		const priceContent = (totalPrice !== '') ? VgHelpers.formatNumberToPrice(totalPrice) : '';
		switch (type) {
			case 'monthly':
				mobileElement.querySelector('.vg-select-quote__subtitle--detail-mobile-monthly').textContent = headingLiteral;
				mobileElement.querySelector('.vg-select-quote__cart-basket--detail-mobile-monthly').textContent = priceContent;
				break;
			case 'paynow':
				mobileElement.querySelector('.vg-select-quote__subtitle--detail-mobile-paynow').textContent = headingLiteral;
				mobileElement.querySelector('.vg-select-quote__cart-basket--detail-mobile-paynow').textContent = priceContent;
				break;
			default:
				return null;
		}
		return true;
	}

	renderItemTable(tableData) {
		let htmlResult = '';

		const tableRows = Object.keys(tableData['table-body']);
		tableRows.forEach(row => {
			const tableRowData = tableData['table-body'][row];
			htmlResult +=
				`<tr>
				<td class="vg-select-quote__table-label">
					<span>${tableRowData['table-row-label']}</span>
				</td>
				<td class="vg-select-quote__table-price">
					<span>${VgHelpers.formatNumberToPrice(tableRowData['table-row-price'])}</span>
				</td>
			</tr>`;
		});

		const totalPrice = tableData['table-footer-total-price'];
		return [htmlResult, totalPrice];
	}

	renderTotalPrice(totalPrice) {
		const tableFooterBasketElement = document.createElement('tfoot');
		tableFooterBasketElement.innerHTML = `
			<tr class="vg-select-quote__table-total">
				<td class="vg-select-quote__table-label">
					<strong>TOTAL</strong>
				</td>
				<td class="vg-select-quote__table-price">
					<strong>${VgHelpers.formatNumberToPrice(totalPrice)}</strong>
				</td>
			</tr>
		`;
		return tableFooterBasketElement;
	}

	removeBasketLoading() {
		const basketResumeSummary = document.querySelector('.vg-select-quote__cart-summary-content');
		basketResumeSummary?.classList.remove('is-loading');
	}

	addBasketLoading() {
		const basketResumeSummary = document.querySelector('.vg-select-quote__cart-summary-content');
		basketResumeSummary?.classList.add('is-loading');
	}

}

export { VgRenderBasket };
